import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import useGetLocations from '../../../../../hooks/HRSetting/use-get-locations.js';
// import NtxTable from '../../../../../components/DataTable/NtxTable.jsx';
// import DataTableComponent from '../../../../../components/DataTable/DataTableComponent.jsx';

const AnalysisTable = ({ ResultList, fromDate, toDate }) => {
  const [search, setSearch] = useState('');
  const { t, i18n } = useTranslation();
  const [Locationid, setLocationid] = useState(null);
  const { Locations, loading } = useGetLocations();

  const filteredSearch = ResultList?.filter((item) => {
    const searchLowerCase = search.toLowerCase();
    return (
      item.employeeNumber?.toLowerCase().includes(searchLowerCase) ||
      item.employeeName?.toLowerCase().includes(searchLowerCase) ||
      item.employeeName2?.toLowerCase().toString().includes(searchLowerCase)
    );
  })?.filter((f) =>
    Locationid === null ? true : f?.locationId === Locationid || f.locationName2 === Locationid
  );

  //________________________________
  const convertToMinutes = (time) => {
    if (!time || typeof time !== 'string') return 0; // التحقق من أن القيمة نصية وصحيحة
    const [hours, minutes] = time.split(':').map(Number); // قراءة الساعات والدقائق فقط
    return (hours || 0) * 60 + (minutes || 0); // حساب الوقت بالدقائق فقط
  };

  const columns = [
    { title: t('Name'), key: 'NameAr', className: 'pe-3' },
    { title: t('Name'), key: 'NameEn' },
    { title: t('EmployeeNumber'), key: 'EmployeeNumber' },
    { title: t('location'), key: 'location' },
    { title: t('Date'), key: 'Date', className: 'text-theme' },

    { title: `${t('Imprint')} 1`, key: 'Finger1' },
    // { title: t('  test'), key: 'test' },

    { title: `${t('Imprint')} 2`, key: 'Finger2' },
    { title: `${t('Delay')} 1`, key: 'LATE1' },
    { title: `${t('Delay')} (min)`, key: 'LATEmin' },
    { title: t('فترة1'), key: 'Duration1' },

    { title: `${t('Imprint')} 3`, key: 'Finger3' },
    { title: `${t('Imprint')} 4`, key: 'Finger4' },
    { title: `${t('Delay')} 2`, key: 'LATE2' },
    { title: t('فترة2 '), key: 'Duration2' },

    // { title: t('Duration'), key: 'Duration' },
    { title: t('ABSENT'), key: 'ABSENT' },
  ];

  const tableData = filteredSearch?.map((item) => {
    let rowClass;

    const calculateDaly = (fingerprintTime, fingerprintTimeAct, allowTime) => {
      const result =
        (fingerprintTime ? convertToMinutes(fingerprintTime) : 0) -
        (fingerprintTimeAct ? convertToMinutes(fingerprintTimeAct) : 0) +
        (allowTime ? convertToMinutes(allowTime) : 0);

      return result < 0 ? Math.abs(result) : 0;
    };
    //حساب التأخيرات لكل بصمة اذا كان دخول تأخير
    // واذا كان خروج الانصراف المبكر يحسب تأخيــر
    const daly1 = calculateDaly(item?.fingerprintTime1, item?.fingerprintTimeAct1, item?.allowIn);
    const daly2 = calculateDaly(item?.fingerprintTime2, item?.fingerprintTimeAct2, item?.allowOut);
    // const daly3 = calculateDaly(item?.fingerprintTime3, item?.fingerprintTimeAct3, item?.allowIn);
    // const daly4 = calculateDaly(item?.fingerprintTime4, item?.fingerprintTimeAct4, item?.allowOut);

    console.log(daly1);
    console.log(daly2);

    return {
      NameAr: item.employeeName2,
      NameEn: item.employeeName,
      EmployeeNumber: item.employeeNumber,
      location: i18n.language === 'en' ? item.locationName : item.locationName2,
      Date: item.transitionDate,

      Finger1: item.fingerprintTimeAct1,

      // test: convertToMinutes(item.fingerprintTimeAct1),

      Finger2: item.fingerprintTimeAct2,
      LATE1: item.dely1,
      LATEmin: convertToMinutes(item.dely1),
      Duration1: item.durationAct1,

      Finger3: item.fingerprintTimeAct3,
      Finger4: item.fingerprintTimeAct4,
      LATE2: item.dely2,
      Duration2: item.durationAct2,

      ABSENT: item.missPunch ? (
        <span className="badge d-block rounded-0 pt-5px w-70px bg-danger text-theme-900"></span>
      ) : (
        '.'
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  const options = {
    retrieve: true,
    paging: true,
    pageLength: 10,
    searching: false,
    ordering: true,
    lengthChange: true, //
    // info: false, //
    columnDefs: [
      // { orderable: false, targets: 7 }, // تعطيل الترتيب للعمود رقم 7
      { visible: false, targets: [1, 9, 13] }, // إخفاء الأعمدة رقم 3 و 4 افتراضيًا
    ],

    order: [[2, 'desc']],
    responsive: true,
    // dom: "Bfrtip",
    dom:
      "<'row'<'col-sm-12 mb-2 mt-2 text-end'B><'col-sm-6'f>>" + // توزيع الأزرار وحقل البحث في سطر واحد
      "<'row'<'col-sm-12'tr>>" + // الجدول
      "<'row'<'col-sm-5'i><'col-sm-7'p>>", // معلومات الجدول والتنقل بين الصفحات
    buttons: [
      {
        extend: 'colvis',
        className: 'btn btn-outline-theme btn-sm text-end',
        text: localStorage.i18nextLng=== 'ar' ? 'إظهار/إخفاء الأعمدة' : 'Column Visibility',
      },
      {
        extend: 'csv',
        className: 'btn btn-outline-theme btn-sm',
        charset: 'utf-8',
        bom: true, // إضافة BOM لضمان دعم الحروف العربية
        text: localStorage.i18nextLng=== 'ar' ? 'تصدير CSV' : 'Export CSV',
        exportOptions: {
          columns: ':visible', // تصدير الأعمدة المرئية فقط
        },
      },
    ],
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-4 d-flex justify-content-start">
          <div className="input-group mb-1">
            <div className="flex-fill position-relative">
              <div className="input-group">
                <div
                  className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
                   >
                  <i className="fa fa-search opacity-5"></i>
                </div>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control ps-35px"
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder={t('Search') + ' ...'}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="form-group mb-1">
            <Select
              classNamePrefix="react-select"
              isLoading={loading}
              isSearchable={true}
              isClearable
              options={Locations?.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(option) => {
                setLocationid(option === null ? null : option.value);
              }}
              placeholder={t('location')}
            />
          </div>
        </div>
        {/* <div className="col-lg-5 text-end">
          <button
            onClick={exportToExcel}
            className="btn btn-outline-theme text-nowrap rounded-2"
            tabIndex={0}
            aria-controls="datatable"
            type="button">
            <span>
              <i className="fa fa-file-excel fa-fw me-1" /> {t('ExportData')}
            </span>
          </button>
        </div> */}
      </div>

      {/* <DataTableComponent
        data={tableData || []}
        columns={columns}
        options={options}
        theadClass=""
        tableClass="table table-hover text-nowrap"
      /> */}
    </div>
  );
};

export default AnalysisTable;
